export function extractErrorMessages(err) {
    let messages = [];
    if (err.response?.data?.error) {
      const errorData = err.response.data.error;
      
      if (errorData.details && errorData.details.error) {
        const nested = errorData.details.error;
        if (typeof nested === 'object' && nested.message) {
          messages.push(nested.message);
        } else if (Array.isArray(nested)) {
          messages.push(...nested);
        } else if (typeof nested === 'string') {
          messages.push(nested);
        }
      } 
      
      else if (errorData.message) {
        if (Array.isArray(errorData.message)) {
          messages.push(...errorData.message);
        } else {
          messages.push(errorData.message);
        }
      }
    }
    
    if (messages.length === 0) {
      messages.push(err.message || 'An error occurred while processing your request');
    }
    
    messages = messages.map(msg => {
      if (typeof msg === 'string') {
        return msg.replace(/^\[|\]$/g, '');
      }
      return msg;
    });
    
    return messages;
  }
  